<!--
 * @Description: 现金宝定期充值
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-30 15:32:31
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div>
        <comp-title-dc back-url-name="autoaccess" :back-url-query="{ activeIndex: '2' }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/moneyBox' }">
                    {{ $const.getXJBParam("name") }}
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/autoaccess?activeIndex=2' }">
                    自动存取款
                </el-breadcrumb-item>
                <el-breadcrumb-item>自动取出</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-money-out">
            <el-form
                ref="fundInfo"
                :rules="rules"
                :model="fundInfo"
                inline-message
                label-width="409px"
                v-on:submit.native.prevent
            >
                <el-form-item
                    label="回款账号："
                    prop="pay"
                    style="position: relative"
                    class="payway-list"
                >
                    <el-select
                        v-model="fundInfo.pay"
                        placeholder="请选择回款账号"
                        :disabled="queryInfo.fundcode"
                    ></el-select>
                    <div
                        v-if="dialogBankLists.length > 0 && !queryInfo.fundcode"
                        class="hot-area"
                        v-on:click="selectBank"
                    ></div>
                </el-form-item>
                <el-form-item label="可用余额：" prop="availableMoney">
                    <div class="available-money-box">
                        <div>
                            <span class="available-money">
                                {{ $util.fmtNum(fundInfo.availableMoney) }}
                            </span>
                            元
                        </div>
                        <div class="money-in" v-on:click="toCurrencyCharge">马上存入</div>
                    </div>
                </el-form-item>
                <el-form-item label="取出周期：" prop="debitcycle" class="form-text">
                    <el-radio-group v-model="fundInfo.debitcycle">
                        <el-radio
                            v-for="item in debitcycleArr"
                            :key="item.subitem"
                            :label="item.subitem"
                            name="debitcycle"
                        >
                            {{ item.subitemname }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    v-if="fundInfo.debitcycle !== '3'"
                    label="取出日期："
                    prop="debitdate"
                >
                    <el-select
                        v-if="fundInfo.debitcycle !== '5'"
                        v-model="fundInfo.debitdate"
                        placeholder="请选择取出日期"
                        v-on:change="queyNextplandate"
                    >
                        <el-option
                            v-for="item in debitdateArr"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                    <p
                        v-if="
                            fundInfo.debitcycle && fundInfo.debitdate && fundInfo.debitcycle !== '5'
                        "
                        class="tips-text"
                    >
                        下次扣款日期
                        {{ formatDate(nextplandate) }}
                    </p>
                </el-form-item>
                <el-form-item label="取出金额：" prop="amount">
                    <el-input
                        v-model.trim="fundInfo.amount"
                        class="prefix"
                        :placeholder="pla"
                        :maxlength="14"
                    />
                </el-form-item>
                <el-form-item v-if="Number(fundInfo.amount)" label="确认金额：">
                    {{ $util.capitalRMB(fundInfo.amount) }}
                </el-form-item>
                <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="16"
                    />
                    <span
                        class="redemp-btn margin-l-10"
                        v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                    >
                        <span class="like-a">忘记密码？</span>
                    </span>
                </el-form-item>
                <el-form-item style="margin-left: -80px">
                    <div
                        v-if="xjbFundFile.length !== 0"
                        class="check-box bar-pad showChenckbox"
                        style="
                            font-size: 14px;
                            display: flex;
                            align-items: flex-start;
                            padding-left: -10px;
                        "
                    >
                        <ul>
                            <li
                                v-for="(item, index) in xjbFundFile"
                                :key="index"
                                class="flex hcenter"
                            >
                                <el-checkbox
                                    v-model="checkboxs[index].checkbox"
                                    size="mini"
                                    text-color="red"
                                ></el-checkbox>
                                <div>
                                    <span class="ml4 c_999">同意</span>
                                    <a
                                        v-if="item.fileid"
                                        class="file-content"
                                        target="_blank"
                                        v-on:click="getClick(index)"
                                    >
                                        《{{ item.title }}》
                                    </a>
                                    <span v-else class="file-content" v-on:click="argRead(item)">
                                        《{{ item.title }}》
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="margin-top: 20px">
                        <button class="back-btn" v-on:click="backFn">返回重选</button>
                        <button
                            :class="
                                'confirm-btn ' +
                                (disabeldFlag || isOpen ? 'disable-btn' : 'active-btn')
                            "
                            :disabled="disabeldFlag || isOpen"
                            v-on:click="submitInfo()"
                        >
                            确定
                        </button>
                    </div>
                </el-form-item>
            </el-form>
            <select-bank
                dialog-title="请选择回款账号"
                :dialog-bank-lists="dialogBankLists"
                :select-bank-show="selectBankShow"
                way="1"
                v-on:select-bank-close="selectBankClose"
                v-on:select-bank-info="selectBankInfo"
            ></select-bank>
            <el-dialog
                title="自动取出设置成功"
                :visible.sync="resultDialog"
                class="prop info-tips"
                width="700px"
                :before-close="resultDialogClose"
            >
                <div>
                    <div class="success-res">
                        <div>
                            <img src="../../assets/img/buy_success.png" alt="" />
                        </div>
                        <div class="success-text">您好，自动取出设置成功！</div>
                    </div>
                    <div class="btn-box">
                        <button class="btn-confirm" v-on:click="resultDialogClose">确定</button>
                    </div>
                </div>
            </el-dialog>
            <pdf-popup
                base64
                :visible="pdfVisible"
                :need-time="needTime"
                :read-file-info-list="currentFileInfoList"
                v-on:close="pdfVisible = false"
            ></pdf-popup>
            <my-dialog
                :title="agrData.title"
                :visible.sync="agrVisible"
                :dialog-close="agrVisibleHide"
                width="800px"
            >
                <div class="protocol-detail" v-html="agrData.content"></div>
                <div class="align-c">
                    <el-button type="primary" style="width: 180px" v-on:click="agrVisible = false">
                        确定
                    </el-button>
                </div>
            </my-dialog>
            <fund-protocol v-model="protocol" :fund="protocolFund" v-on:all-read="generalBuy" />
            <footer-questions
                v-if="$const.warmReminderDisplay"
                class="footer-questions"
                :warning-html="warningHtml"
            ></footer-questions>
        </div>
    </div>
</template>
<script>
import selectBank from "@/components/layout/selectBank.vue";
import userApi from "@/api/user";
import mixin from "@/assets/js/mixin";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import myDialog from "@/components/layout/myDialog.vue";
import fundProtocol from "@/components/form/fundProtocol";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";
import commonApi from "@/api/common";
import format from "date-fns/format";

export default {
    name: "MoneyOut",
    components: { selectBank, PdfPopup, myDialog, fundProtocol, footerQuestions },
    mixins: [mixin],
    data() {
        return {
            queryInfo: {},
            fund: {},
            xjbFundFile: [],
            xjbFundFileFlag: false,
            currentFileInfoList: [], // 当前阅读信批文件
            checkboxs: [],
            pdfVisible: false,
            protocol: false,
            protocolFund: {},
            needTime: false,
            agrVisible: false,
            agrData: {},
            pla: "请输入取出金额",
            isOpen: false,
            fundInfo: {
                pay: "",
                availableMoney: "0.00",
                debitcycle: "",
                debitdate: "",
                amount: "",
                pwd: ""
            },
            isPwdCheck: false,
            resultDialog: false,
            debitcycleArr: [],
            debitdateArr: [],
            selectBankShow: false,
            dialogBankLists: [],
            bankInfo: {},
            limit: { text: "取出金额范围为：", min: "0", max: "0" }, // 限额
            rules: {
                // 校验规则配置
                pay: [
                    {
                        required: true,
                        message: "请选择回款账号",
                        trigger: "change"
                    }
                ],
                debitcycle: [
                    {
                        required: true,
                        message: "请选择取出周期",
                        trigger: "change"
                    }
                ],
                debitdate: [{ validator: this.checkDebitdate, trigger: "change" }],
                amount: [
                    {
                        validator: this.amountLimit,
                        mes: "取出金额",
                        trigger: "change"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            warningHtml: "",
            nextplandate: ""
        };
    },
    computed: {
        disabeldFlag() {
            if (this.checkboxs.length == 0) {
                return false;
            }
            for (let i = 0; i < this.checkboxs.length; i++) {
                if (!this.checkboxs[i].checkbox) {
                    return true;
                }
            }
            return false;
        }
    },
    watch: {
        "fundInfo.debitcycle"(val) {
            if (val === "0") {
                let arr = this.$cache.getDict("110207");
                let filterArr = arr.filter(
                    (item, index) =>
                        item.subitem !== "29" && item.subitem !== "30" && item.subitem !== "31"
                );
                this.debitdateArr = filterArr.sort((a, b) => a.itemorder - b.itemorder);
            } else if (val === "1" || val === "2") {
                let arr = this.$cache.getDict("110213");
                this.debitdateArr = arr.sort((a, b) => a.itemorder - b.itemorder);
            }
            let _x = this.debitdateArr.length > 0 ? this.debitdateArr[0].subitem : "";
            if (this.queryInfo.fundcode && this.queryInfo.investcycle === val) {
                if (val === "0") {
                    _x = `0${this.queryInfo.investcyclevalue}`.slice(-2);
                    this.queryInfo.investcyclevalue = _x;
                } else {
                    _x = this.queryInfo.investcyclevalue;
                }
            }
            setTimeout(() => {
                this.$set(this.fundInfo, "debitdate", _x);
                if (_x !== "3") {
                    this.queyNextplandate();
                }
            }, 10);
        },
        "fund.tano"(val) {
            if (val) {
                this.$nextTick(() => {
                    this.queyNextplandate();
                });
            }
        }
    },
    mounted() {
        this.warningHtml = warningHtml.warningHtml12;
        this.$cache.getDict("110009").forEach((item) => {
            if (item.subitem != "3") {
                this.debitcycleArr.push(item);
            }
        });
        this.isPwdCheck = this.$cache.getPwdCheck("59");
        this.queryInfo = this.$route.query;
        this.queryXjbFundInfo();
    },
    methods: {
        resultDialogClose() {
            this.resultDialog = false;
            this.$router.push({ name: "moneybox" });
        },
        // 查询现金宝信息
        async queryXjbFundInfo() {
            // 修改操作
            if (this.queryInfo.fundcode) {
                this.fundInfo.debitcycle = this.queryInfo.investcycle;
                const fundRes = await fundApi.getFundLists({
                    fundcode: this.queryInfo.fundcode,
                    pagesize: 10,
                    pagenum: 1
                });
                if (fundRes.data) {
                    this.fund = fundRes.data.list[0];
                    this.protocolFund = fundRes.data.list[0];
                }
            } else {
                // 新增操作
                this.fund = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
                this.protocolFund = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
            }
            this.getFileInfo();
            this.getBuyWay();
        },
        // 定投前查询
        async getBuyWay() {
            this.dialogBankLists = [];
            const res = await fundApi.tradePlan({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            });
            if (res.data && res.data.returnList2) {
                res.data.returnList2.forEach((item) => {
                    if (
                        item.paycenterid != "0001" &&
                        item.paycenterid != "1000" &&
                        (this.$util.showCounterCard() || item.banktype != "1")
                    ) {
                        this.dialogBankLists.push(item);
                    }
                });
            }
            this.dialogBankLists.forEach((item) => {
                res.data.returnList3.forEach((item1) => {
                    if (item.channelid == item1.channelid) {
                        item.netnominbuy = item1.netnominbuy;
                        item.netnomaxbuy = item1.netnomaxbuy;
                    }
                });
            });
            const reqRes = await userApi.getMyBankCards();
            if (reqRes.data.data) {
                this.dialogBankLists.forEach((item) => {
                    reqRes.data.data.forEach((reqItem) => {
                        if (reqItem.paycenterid + reqItem.bankcode == item.channelid) {
                            item.perdaymax = reqItem.perdaymax;
                            item.maxlimitsingle = reqItem.maxlimitsingle;
                        }
                    });
                });
            }
            if (this.queryInfo.fundcode) {
                const queryBank = this.dialogBankLists.find((item) => {
                    return (
                        this.queryInfo.channelid == item.channelid &&
                        this.queryInfo.transactionaccountid == item.realtransactionaccountid
                    );
                });
                if (queryBank) {
                    this.selectBankInfo(queryBank);
                }
                this.fundInfo.amount = this.queryInfo.sellvol;
            }
        },
        // 获取提示文件信息
        async getFileInfo() {
            this.fund.proto = "sell";
            this.$util.getSdxProtocol(this.fund, (res) => {
                this.fund = res;
                this.protocolFund = JSON.parse(JSON.stringify(res));
                this.protocolFund.protoArr = [];
                if (res.protoArr && res.protoArr.length > 0) {
                    res.protoArr.forEach((item) => {
                        item.filename = item.title;
                        if (item.fileid == null || !item.fileid) {
                            item.fileid = "";
                        }
                        this.xjbFundFile.push(item);
                        this.checkboxs.push({ checkbox: false });
                    });
                }
                this.xjbFundFileFlag = true;
            });
        },
        getClick(index) {
            this.currentFileInfoList = [this.xjbFundFile[index]];
            this.needTime = false;
            this.pdfVisible = true;
        },
        backFn() {
            this.$router.push({
                name: "autoaccess",
                query: { activeIndex: "2" }
            });
        },
        submitInfo() {
            this.$refs["fundInfo"].validate((valid) => {
                if (valid) {
                    if (this.xjbFundFile.length > 0) {
                        commonApi.agreementLeaveTracesLog(
                            this,
                            {
                                eventid: this.$const.RECORD.cms_protocol_agreement_agree + "/o",
                                eventname: `协议同意`
                            },
                            this.xjbFundFile
                        );
                    }
                    let _change = false;
                    if (
                        this.queryInfo.sellvol != this.fundInfo.amount ||
                        this.queryInfo.investcycle != this.fundInfo.debitcycle ||
                        this.queryInfo.investcyclevalue != this.fundInfo.debitdate ||
                        this.queryInfo.channelid != this.bankInfo.channelid ||
                        this.queryInfo.transactionaccountid !=
                            this.bankInfo.realtransactionaccountid
                    ) {
                        _change = true;
                    }
                    if (!_change) {
                        this.$alert("您未修改任何定投信息，无需提交", "信息未变动提示", "", {
                            confirmButtonText: "确定",
                            type: "warning",
                            callback: (action) => {}
                        })
                            .then(() => {
                                return false;
                            })
                            .catch(() => {
                                return false;
                            });
                        return;
                    }
                    this.protocol = true;
                } else {
                    this.$errorScroll();
                }
            });
        },
        generalBuy(val) {
            this.protocol = false;
            if (!val) return;
            const _x = this.getInvest();
            let data = {
                contractno: this.readappno,
                sellvol: this.fundInfo.amount,
                firstinvestdate: "",
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype,
                transactionaccountid: this.bankInfo.transactionaccountid,
                investcycle: "",
                investcyclevalue: "",
                investperiods: this.fundInfo.debitcycle,
                investperiodsvalue: _x.investcyclevalue,
                bankcode: this.bankInfo.bankcode,
                channelid: this.bankInfo.channelid,
                paycenterid: this.bankInfo.paycenterid,
                nonexistdayflag: "",
                tradepassword: this.$util.enc(this.fundInfo.pwd),
                saveplanmode: "1",
                saveplanflag: "5",
                buyflag: this.fund.riskmismatchflag == "1" ? "1" : "2",
                riskwarnflag: this.fund.riskwarnflag == "1" ? "1" : "2",
                highriskwarnflag: this.fund.highriskwarnflag == "1" ? "1" : "2"
            };
            // 修改
            if (this.queryInfo.fundcode) {
                data.planno = this.queryInfo.planno;
                data.transactionaccountid = this.bankInfo.realtransactionaccountid;
            }
            // 下单
            this.planOpen(data);
        },
        async planOpen(params) {
            this.isOpen = true;
            setTimeout(() => {
                this.isOpen = false;
            }, 3000);
            const res = await fundApi.planOpen(params);
            if (res.data) {
                this.resultDialog = true;
            }
        },
        // 初始化扣款周期和扣款日期值
        getInvest() {
            let _x = {
                investperiods: "",
                investperiodsvalue: "",
                investcyclevalue: ""
            };
            const selVal = this.fundInfo.debitdate;
            if (this.fundInfo.debitcycle === "0") {
                _x.investperiods = "0";
                _x.investperiodsvalue = "1";
                _x.investcyclevalue = selVal;
            } else if (this.fundInfo.debitcycle === "1") {
                _x.investperiods = "1";
                _x.investperiodsvalue = "1";
                _x.investcyclevalue = selVal;
            } else if (this.fundInfo.debitcycle === "2") {
                _x.investperiods = "1";
                _x.investperiodsvalue = "2";
                _x.investcyclevalue = selVal;
            } else if (this.fundInfo.debitcycle === "5") {
                _x.investperiods = "2";
                _x.investperiodsvalue = "1";
                _x.investcyclevalue = "1";
            } else {
                _x.investperiods = "";
                _x.investperiodsvalue = "";
                _x.investperiodsvaluedesc = "";
            }
            return _x;
        },
        // 处理限额
        amountLimit(rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        checkDebitdate(rule, value, callback) {
            if (value.trim() === "" && value.trim() !== "5") {
                callback(new Error("请选择取出日期"));
            } else {
                callback();
            }
        },
        selectBank() {
            this.selectBankShow = true;
        },
        selectBankClose(value) {
            this.selectBankShow = false;
        },
        selectBankInfo(bankInfo) {
            this.bankInfo = bankInfo;
            this.fundInfo.pay =
                this.$cache.getDict("110079", this.bankInfo.paycenterid) +
                "-" +
                this.$cache.getDict("110080", this.bankInfo.bankcode).substr(-4, 4) +
                "(" +
                this.bankInfo.depositcard.slice(-4) +
                ")";
            this.fundInfo.availableMoney = this.bankInfo.xjbasset ? this.bankInfo.xjbasset : "0.00";
            this.$set(
                this.limit,
                "min",
                this.bankInfo.netnominbuy ? this.bankInfo.netnominbuy : "0"
            );
            this.$set(
                this.limit,
                "max",
                Number(this.bankInfo.netnomaxbuy) - Number(this.fundInfo.availableMoney) > 0
                    ? this.fundInfo.availableMoney
                    : this.bankInfo.netnomaxbuy
            );
            this.pla =
                this.$util.fmtNum(this.limit.min) +
                "元起，最多可取" +
                this.$util.fmtNum(this.limit.max) +
                "元";
        },
        agrVisibleHide() {
            this.agrVisible = false;
        },
        argRead(item) {
            this.agrVisible = true;
            this.agrData = item;
        },
        toCurrencyCharge() {
            this.$router.push({ name: "currencycharge" });
        },
        formatDate(date) {
            if (date) {
                return format(date, "YYYY-MM-DD");
            }
        },
        async queyNextplandate() {
            const { debitcycle, debitdate } = this.fundInfo;
            if (debitcycle !== "3" && this.fund.tano && debitcycle != "" && debitdate != "") {
                const { data } = await userApi.getFirstPlanDay({
                    tano: this.fund.tano,
                    fundcode: this.fund.fundcode,
                    planperiods: debitcycle,
                    planperiodsvalue: debitdate,
                    startdate: format(new Date(), "YYYYMMDD")
                });
                this.nextplandate = data.nextplandate;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-money-out {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding: 40px 0 21px 0;
    .payway-list {
        position: relative;
        .hot-area {
            width: 400px;
            height: 40px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99 !important;
            cursor: pointer;
        }
        .add-bank-btn {
            position: absolute;
            left: 410px;
            font-size: 14px;
            font-weight: normal;
            color: #1890ff;
            cursor: pointer;
        }
    }
    .available-money-box {
        display: flex;
        align-items: center;
        .available-money {
            font-size: 22px;
            font-weight: normal;
            color: var(--color-primary);
            vertical-align: top;
        }
        .money-in {
            width: 74px;
            text-align: center;
            height: 26px;
            line-height: 26px;
            border-radius: 20px;
            background: #ffecec;
            font-size: 14px;
            font-weight: normal;
            color: var(--color-primary);
            margin-left: 29px;
            cursor: pointer;
        }
    }

    .back-btn {
        width: 180px;
        height: 42px;
        line-height: 42px;
        border-radius: 2px;
        background: #e4e4e4;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #666666;
        border: none;
        cursor: pointer;
    }
    .confirm-btn {
        width: 180px;
        height: 42px;
        line-height: 42px;
        border-radius: 2px;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        border: none;
        margin-left: 40px;
    }
    .active-btn {
        background: var(--color-primary);
        cursor: pointer;
    }
    .disable-btn {
        background: #f7b2b8;
    }
    .success-res {
        margin: 40px 0 30px;
        width: 660px;
        height: 242px;
        border-radius: 6px;
        background: #f9f9f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .success-text {
            font-size: 26px;
            font-weight: 500;
            margin-top: 23.85px;
            color: #333333;
        }
    }
    .btn-box {
        text-align: center;
        padding-bottom: 56px;
        .btn-confirm {
            width: 180px;
            text-align: center;
            height: 42px;
            line-height: 42px;
            border-radius: 2px;
            background: var(--color-primary);
            color: #ffffff;
            border: none;
            cursor: pointer;
        }
    }
    .file-content {
        text-decoration: none;
        color: var(--color-primary);
        cursor: pointer;
    }
    .protocol-detail {
        padding: 20px 10px;
        max-height: 80vh;
        min-height: 10vh;
        overflow: scroll;
    }
    .footer-questions {
        padding: 0 20px;
    }
    .el-input,
    .el-select {
        width: 400px;
    }
    .el-input__inner {
        font-size: 22px !important;
        font-weight: normal;
        color: #333333;
    }
    .margin-l-10 {
        margin-left: 10px;
    }
    :deep(.el-form-item__label) {
        padding: 0;
        font-size: 14px;
        font-weight: normal;
        color: #333333;
    }
    :deep(.el-form-item__label:before) {
        display: none;
    }
    .tips-text {
        color: #999999;
        font-size: 14px;
    }
}
</style>
